import Vue from 'vue'
import {
  Calendar,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Eye,
  GitMerge,
  Home,
  Import,
  MoreHorizontal,
  Pencil,
  Plus,
  Table,
  Trash2,
  User,
  UserPlus,
  X,
} from 'lucide-vue'

// Global icon registry. Replaces the Font Awesome kit (`<i class="fas fa-*">`).
// Icons inherit color via `currentColor` and are sized to 1em by the
// `.lucide-icon` rule in App.vue, so they match the surrounding text like the
// old glyphs did. Add a new icon here and reference it as `<IconName />`.
const icons = {
  IconCalendar: Calendar,
  IconCheck: Check,
  IconChevronDown: ChevronDown,
  IconChevronLeft: ChevronLeft,
  IconChevronRight: ChevronRight,
  IconChevronUp: ChevronUp,
  IconClose: X,
  IconEllipsis: MoreHorizontal,
  IconEye: Eye,
  IconHome: Home,
  IconImport: Import,
  IconMerge: GitMerge,
  IconPencil: Pencil,
  IconPlus: Plus,
  IconTable: Table,
  IconTrash: Trash2,
  IconUser: User,
  IconUserPlus: UserPlus,
}

Object.entries(icons).forEach(([name, component]) => {
  Vue.component(name, component)
})
